const Marquee = ({ items, className = "", itemClassName = "", speed = 32 }) => {
  const row = [...items, ...items, ...items];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`}>
      <div className="marquee-track items-center" style={{ animationDuration: `${speed}s` }}>
        {row.map((item, i) => (
          <span key={i} className={`inline-flex items-center ${itemClassName}`}>
            <span>{item}</span>
            <span className="mx-8 inline-block h-2 w-2 rotate-45 bg-current opacity-60" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
